import { awsListPage } from './awsListPage';
import { awsListByDates } from './awsListByDates';
import { awsSearchObjects } from './awsSearchObjects';
import formatAwsReturn from './FormatData';

const MS_IN_DAY = 24 * 60 * 60 * 1000;

export class S3AudithStore {
  constructor() {
    this.state = {
      items: [],
      nextMarker: null,
      thresholdTs: null,
      initialized: false,
    };
  }

  getState() {
    return this.state;
  }

  async loadInitial({ days = 30, pageSize = 1000, maxPages = 1, onProgress } = {}) {
    if (this.state.initialized && this.state.items.length > 0) {
      if (typeof onProgress === 'function') onProgress(1);
      return this.state;
    }

    // Estratégia baseada em prefixos por data (YYYY/MM/DD) para trazer os mais recentes primeiro
    if (typeof onProgress === 'function') onProgress(0);
    const { items: recentItems, nextDateOffset } = await awsListByDates({ limit: pageSize, startOffsetDays: 0, maxDaysToScan: days });
    const collected = recentItems;
    const thresholdTs = Date.now() - days * MS_IN_DAY;
    const base = collected;
    const formatted = formatAwsReturn(base).sort((a, b) => (b.lastModifiedTs - a.lastModifiedTs));
    const limited = formatted.slice(0, pageSize);

    this.state = {
      items: limited,
      nextMarker: null,
      thresholdTs,
      // usamos nextDateOffset para paginar por datas quando disponível
      nextDateOffset,
      initialized: true,
    };
    if (typeof onProgress === 'function') onProgress(1);
    return this.state;
  }

  async loadNextPage({ pageSize = 1000, onProgress } = {}) {
    if (typeof onProgress === 'function') onProgress(0);
    // Primeiro tenta paginar por data (mais recente -> antigo)
    if (this.state.nextDateOffset != null) {
      const { items, nextDateOffset } = await awsListByDates({ limit: pageSize, startOffsetDays: this.state.nextDateOffset, maxDaysToScan: 365 });
      if (typeof onProgress === 'function') onProgress(0.5);
      const formatted = formatAwsReturn(items).sort((a, b) => (b.lastModifiedTs - a.lastModifiedTs));
      this.state = {
        ...this.state,
        items: [...this.state.items, ...formatted].sort((a, b) => (b.lastModifiedTs - a.lastModifiedTs)),
        nextDateOffset,
      };
      if (typeof onProgress === 'function') onProgress(1);
      return this.state;
    }
    // Fallback para paginação por marker quando necessário
    if (!this.state.nextMarker) return this.state;
    const { items, nextMarker } = await awsListPage({ marker: this.state.nextMarker, maxKeys: pageSize });
    if (typeof onProgress === 'function') onProgress(0.5);
    const formatted = formatAwsReturn(items).sort((a, b) => (b.lastModifiedTs - a.lastModifiedTs));
    this.state = {
      ...this.state,
      items: [...this.state.items, ...formatted].sort((a, b) => (b.lastModifiedTs - a.lastModifiedTs)),
      nextMarker,
    };
    if (typeof onProgress === 'function') onProgress(1);
    return this.state;
  }

  async search({ query, limit = 200, onProgress } = {}) {
    const { items } = await awsSearchObjects({ query, limit, onProgress });
    const formatted = formatAwsReturn(items).sort((a, b) => (b.lastModifiedTs - a.lastModifiedTs));
    this.state = {
      ...this.state,
      items: formatted,
      // durante busca, não usamos paginação por data/marker
      nextMarker: null,
      nextDateOffset: null,
    };
    return this.state;
  }
}

export default S3AudithStore;
